import { LOCATION_OPERATIONAL_STATUS, LOCATION_PHYSICAL_TYPE } from './Location.utils.ValueSets';

/**
 * * It takes a set of values and returns a Location resource in FHIR format
 * @param values - The values from the form
 * @returns A locationData object.
 */
export function mLocation(values) {
  const locationData = {
    resourceType: 'Location',
    name: values.name,
  };

  locationData.id = values.id;
  locationData.description = values.description;
  locationData.status = values.status;
  locationData.mode = values.mode;

  if (values.operationalStatus !== '') {
    locationData.operationalStatus = {
      system: LOCATION_OPERATIONAL_STATUS.definingURL,
      code: values.operationalStatus,
      display: LOCATION_OPERATIONAL_STATUS.values.find((item) => item.code === values.operationalStatus).display,
    };
  }

  if (values.physicalType !== '') {
    locationData.physicalType = {
      coding: [
        {
          system: LOCATION_PHYSICAL_TYPE.definingURL,
          code: values.physicalType,
          display: LOCATION_PHYSICAL_TYPE.values.find((item) => item.code === values.physicalType).display,
        },
      ],
    };
  }

  if (values.partOf !== '') {
    locationData.partOf = {
      reference: `Location/${values.partOf}`,
      type: 'Location',
    };
  }

  return locationData;
}
